import React from 'react';
import PhotoMapChoser from "./Components/PhotoMapChoser";
import Folder from "./Components/folder";
import Create from "./Components/creatingfolderwait";
import Cam from "./Components/Cam";
import Password from "./Components/Password";
import Upload from "./Components/FileUpload";


export default class App extends React.Component {

    constructor(props) {
        super(props);
        this.page = this.page.bind(this);
        this.changeToken = this.changeToken.bind(this);
    }

    page(newPAge, id = undefined) {
        newPAge = (this.state.id === undefined && id === undefined) ? "menu" : newPAge;
        this.setState({id: id}, () => this.setState({page: newPAge}));
    }

    parseJwt(token)  {
        try {
            return JSON.parse(atob(token.split('.')[1]));
        } catch (e) {
            return null;
        }
    };

    changeToken(token) {
        this.setState({token: token});
        this.setState({admin: this.parseJwt(token).admin === "1"});
    }


    state = {page: "menu", id: undefined, isFull: false, token: undefined};

    render() {
        return (
            <div>
                {this.state.token === undefined && <Password changeToken={this.changeToken}/> }
                {this.state.token !== undefined && <div>
                    {this.state.page === "menu" && <PhotoMapChoser token={this.state.token} admin={this.state.admin} page={this.page}/>}
                    {this.state.page === "folder" &&
                    <Folder token={this.state.token}  admin={this.state.admin} page={this.page} folderid={this.state.id}/>}
                    {this.state.page === "create" &&
                    <Create token={this.state.token} page={this.page} name={this.state.id}/>}
                    {this.state.page === "cam" && <Cam token={this.state.token} page={this.page} id={this.state.id}/>}
                    {this.state.page === "upload" && <Upload id={this.state.id} token={this.state.token}  page={this.page}/>}
                </div>}
            </div>
        );
    }


}
